import { getProtobufTimestamp } from '../util/get_protobuf_timestamp';
import { useCallback } from 'react';
import { useRoomSession } from '../context/room_session';
import { useCompanySettings } from '../context/company_settings';
import { useCallSource } from '../context/call_source';
export function useCenterToolbar() {
    const { callRequeueEnabledForSourceYn } = useCallSource();
    const roomSession = useRoomSession();
    const settings = useCompanySettings();
    const addBookmark = useCallback(() => {
        roomSession.bookmarks.addBookmark({
            timestamp: getProtobufTimestamp(),
        });
    }, [roomSession.bookmarks]);
    const showGps = !!settings?.gpsEnabled;
    return {
        addBookmark,
        showGps,
        showCallTransferButton: !!callRequeueEnabledForSourceYn,
    };
}
//# sourceMappingURL=use_center_toolbar.js.map